(function initializePostButton(){
    $( document ).on( 'click', '._post-button', function( event ){
        var _this = $( this );
        var method = _this.attr( 'data-method' ) || 'post';
        var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );

        if( !_this.attr( 'disabled' ) ){
            var formData = _this.attr( 'data-form' );
            var form = document.createElement( 'form' );
            var hiddenField = document.createElement( 'input' );

            if( formData ){
                try{
                    formData = JSON.parse( formData );
                }
                catch( err ){
                    console.err( 'Form data not parsed' );
                    console.err( err );
                }
            }

            if( typeof formData === 'object' ){
                for( const prop in formData ){
                    var field = document.createElement( 'input' );
                    field.setAttribute( 'name', prop );
                    field.setAttribute( 'value', formData[ prop ] );

                    form.appendChild( field );
                }
            }

            hiddenField.setAttribute( 'type', 'hidden' );
            hiddenField.setAttribute( 'name', '_method' );
            hiddenField.setAttribute( 'value', method.toUpperCase() );

            if( token !== null ){
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );
                form.appendChild( tokenField );
            }

            form.setAttribute( 'method', 'POST' );
            form.setAttribute( 'action', _this.attr( 'data-href' ) );
            form.appendChild( hiddenField );

            document.body.appendChild( form );

            _this.attr( 'disabled', true );

            form.submit();
        }
    } );
})();
